import React from "react";
import { Tag } from "antd";
import { getReviewStatusLabel } from "../services/firestoreTracking.service";

export const ConnectionStatusBadge = ({ status }) => {
  const normalizedStatus = (status || "offline").toString();
  const palette =
    normalizedStatus === "live"
      ? {
          dot: "bg-emerald-500",
          pulse: "bg-emerald-400/45",
          shell: "border-emerald-200 bg-emerald-50 text-emerald-700",
        }
      : normalizedStatus === "stale"
      ? {
          dot: "bg-amber-500",
          pulse: "bg-amber-400/45",
          shell: "border-amber-200 bg-amber-50 text-amber-700",
        }
      : normalizedStatus === "ended"
      ? {
          dot: "bg-stone-500",
          pulse: "bg-stone-400/20",
          shell: "border-stone-200 bg-stone-50 text-stone-700",
        }
      : {
          dot: "bg-rose-500",
          pulse: "bg-rose-400/45",
          shell: "border-rose-200 bg-rose-50 text-rose-700",
        };

  return <span
    className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] ${palette.shell}`}
  >
    <span className="relative flex h-2.5 w-2.5">
      <span className={`absolute inline-flex h-full w-full rounded-full animate-ping ${palette.pulse}`} />
      <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${palette.dot}`} />
    </span>
    {normalizedStatus}
  </span>;
};

export const InfringementTypeBadge = ({ type }) => {
  const normalizedType = (type || "speeding").toString();
  const color = normalizedType === "offline" ? "purple" : "volcano";
  const label = normalizedType === "offline" ? "Offline" : "Speeding";
  return <Tag color={color} className="rounded-full px-3 py-1 uppercase">{label}</Tag>;
};

export const ReviewStatusBadge = ({ status }) => {
  const normalizedStatus = (status || "pending").toString();
  const color =
    normalizedStatus === "accepted"
      ? "green"
      : normalizedStatus === "dismissed"
      ? "default"
      : normalizedStatus === "uncertain"
      ? "gold"
      : "blue";
  return <Tag color={color} className="rounded-full px-3 py-1 uppercase">{getReviewStatusLabel(normalizedStatus)}</Tag>;
};

export const BackendStatusBadge = ({ status }) => {
  const normalizedStatus = (status || "pending").toString();
  const color =
    normalizedStatus === "confirmed"
      ? "red"
      : normalizedStatus === "resolved"
      ? "green"
      : normalizedStatus === "open"
      ? "orange"
      : "default";
  return <Tag color={color} className="rounded-full px-3 py-1 uppercase">{normalizedStatus.replace(/_/g, " ")}</Tag>;
};
